<template>
  <v-container fluid>
    <page-header
      title="사용자별 등록 권한 조회"
      :useList="buttonUseList"
      :usePermission="true"
      @btnSearch="search"
    />
    <v-row>
      <v-col class="py-2">
        <v-card class="px-4">
          <v-form ref="form">
            <v-row>
              <v-col cols="12" md="4">
                <!-- 시스템 -->
                <v-select dense outlined hide-details :label="$t('system')" :items="systemList" item-value="app_id" item-text="app_nm" v-model="userGroupGrid.retrieveData.app_id"></v-select>
              </v-col>
              <v-col cols="12" md="4" align-self="center">
                <!-- 구분 -->
                <v-radio-group v-model="radio1" :label="$t('sortation')" row hide-details>
                  <v-radio :label="$t('user')" value="A"></v-radio>
                  <v-radio :label="$t('organization')" value="B"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="4">
                <!-- 아이디 -->
                <v-text-field class='user_id-tf' dense outlined hide-details="auto" :label="$t('id')" v-model="popup.retrieveData.user_id" :rules="[value => !!value || '아이디를 입력해주세요.']">
                  <template v-slot:append-outer>
                    <v-btn small color="primary" height="40" @click="openUserListPopup">
                      {{ $t('label.to-search') }}
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="5">
        <!-- 그룹 -->
        <v-card>
          <v-card-title class="font-weight-bold">
            {{ $t('group') }}
          </v-card-title>
          <v-card-text class="pt-0">
            <realgrid
              ref="userGroupGrid"
              class="mt-3 w-full"
              :options="userGroupGrid.gridOption"
              :fields="userGroupGrid.gridFields"
              :columns="userGroupGrid.gridColumns"
              :retrieveApi="retrieveuserGroupGrid"
              :retrieveData="userGroupGrid.retrieveData"
              :height="menusGrid.height"
            ></realgrid>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="7">
        <!-- 메뉴 -->
        <v-card>
          <v-card-title class="font-weight-bold">
            {{ $t('menu') }}
          </v-card-title>
          <v-card-text class="pt-0">
            <realgrid
              ref="menusGrid"
              class="mt-3 w-full"
              :options="menusGrid.gridOption"
              :fields="menusGrid.gridFields"
              :columns="menusGrid.gridColumns"
              :retrieveApi="retrieveMenuGrid"
              :retrieveData="userGroupGrid.retrieveData"
              :height="menusGrid.height"
            ></realgrid>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="flags.userListPopup" width="1000" scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          사용자 조회
          <v-spacer/>
          <v-btn icon dark @click="flags.userListPopup = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-5">
          <member-search
            ref="memberSearchComp"
            :value="popup.retrieveData"
            :selected="getSelectedUser"
          />
        </v-card-text>
        <v-divider/>
        <v-card-actions class="justify-end">
          <v-btn color="primary" @click="flags.userListPopup = false">
            {{$t('label.cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="flags.deptListPopup" width="1000" scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          사용자 조회
          <v-spacer/>
          <v-btn icon dark @click="flags.deptListPopup = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-5">
          <dept-search ref="deptSearchComp" :value="popup.retrieveData" :selected="getSelectedDept"></dept-search>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="justify-end">
          <v-btn color="primary" @click="flags.deptListPopup = false">
            {{$t('label.cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Realgrid from '@/components/grid/Realgrid' // 리얼그리드 컴포넌트 사용
import DeptSearch from '@/views/manager/Organization'
import MemberSearch from '@/views/manager/Members'
import { getUserAuth, getUserGroups } from '@/api/manager/auth/userauth' // sample 데이터 API
import { getSystems } from '@/api/manager/program' // 프로그램 데이터 API
import envs from '@/envs'
import PageHeader from '@/layout/components/PageHeader'

export default {
  name: 'UserAuth',
  components: {
    Realgrid,
    DeptSearch,
    MemberSearch,
    PageHeader
  },
  data() {
    return {
      buttonUseList: [
        'btnSearch'
      ],
      envsSys: envs.systemId,
      systemList: [],
      retrieveData: {
        app_id: '',
        user_id: 'A'
      },
      popup: {
        retrieveData: {
          company: '',
          bsns_cd: '',
          user_id: '',
          kor_nm: '',
          dept_cd: '',
          custom_act: ''
        }
      },
      radio1: 'A',
      menusGrid: {
        retrieveData: {
          // 조회 파라미터
          user_id: '', // 사용자 아이디
          authgrp_cd: '', // 사용자명
          app_id: '' // 시스템 코드
        }, // 그리드 옵션값
        gridOption: {
          gridView: {
            edit: {
              editable: false
            },
            checkBar: {
              // 체크바 숨김
              visible: false
            },
            stateBar: {
              visible: false
            },
            panel: {
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            }
          },
          dataProvider: {
            softDeleting: true
          }
        },
        // 그리드 filed 배열
        gridFields: [],
        // 그리드 컬럼 배열
        gridColumns: [],
        height: 500
      },
      userGroupGrid: {
        retrieveData: {
          // 조회 파라미터
          user_id: '', // 사용자 아이디
          user_nm: '', // 사용자명
          app_id: '' // 시스템 코드
        },
        // 그리드 옵션값
        gridOption: {
          gridView: {
            edit: {
              editable: false
            },
            panel: {
              // 상단 패널 숨김
              visible: false
            },
            checkBar: {
              // 체크바 숨김
              visible: false
            },
            stateBar: {
              // 상태바 숨김
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            },
            select: {
              //  그리드 셀 선택 옵션을 row 한줄로 한다.
              style: 'singleRow'
            }
          },
          dataProvider: {
            softDeleting: true
          }
        },
        // 그리드 filed 배열
        gridFields: [],
        // 그리드 컬럼 배열
        gridColumns: []
      },
      flags: {
        userListPopup: false,
        deptListPopup: false,
        inited: false,
        type: true
      },
      contentPopupWidths: {
        // 팝업 가로값
        widthM: 'w-full',
        widthLg: 'w-4/5',
        widthXl: 'w-4/5'
      }
    }
  },
  created() {
    this.retrieveData.app_id = this.envsSys
    // userGroupGrid 셋팅
    this.userGroupGrid.gridFields = [
      { fieldName: 'authgrp_cd', dataType: 'string' },
      { fieldName: 'authgrp_nm', dataType: 'string' },
      { fieldName: 'group_belong', dataType: 'string' },
      { fieldName: 'user_id', dataType: 'string' }
    ]
    // userGroupGrid 컬럼
    this.userGroupGrid.gridColumns = [
      {
        name: 'authgrp_cd',
        fieldName: 'authgrp_cd',
        header: {
          text: 'Group ID'
        },
        width: 50,
        visible: true,
        styles: {
          textAlignment: 'center'
        }
      },
      {
        name: 'authgrp_nm',
        fieldName: 'authgrp_nm',
        header: {
          text: 'Group Name'
        },
        width: 100,
        visible: true,
        styles: {
          textAlignment: 'center'
        }
      }
    ]

    // 그리드 필드
    this.menusGrid.gridFields = [
      { fieldName: 'app_id', dataType: 'string' },
      { fieldName: 'app_nm', dataType: 'string' },
      { fieldName: 'menu_id', dataType: 'string' },
      { fieldName: 'menu_nm', dataType: 'string' },
      { fieldName: 'aclc', dataType: 'string' },
      { fieldName: 'aclr', dataType: 'string' },
      { fieldName: 'aclu', dataType: 'string' },
      { fieldName: 'acld', dataType: 'string' },
      { fieldName: 'extacl', dataType: 'string' }
    ]
    // 그리드 컬럼
    this.menusGrid.gridColumns = [
      {
        name: 'appid',
        fieldName: 'app_id',
        header: {
          text: '시스템코드'
        },
        width: 40,
        visible: true,
        styles: {
          textAlignment: 'center'
        }
      },
      {
        name: 'appnm',
        fieldName: 'app_nm',
        header: {
          text: '시스템명'
        },
        width: 100,
        visible: true
      },
      {
        name: 'menuid',
        fieldName: 'menu_id',
        header: {
          text: '메뉴ID'
        },
        width: 50,
        visible: false
      },
      {
        name: 'menunm',
        fieldName: 'menu_nm',
        header: {
          text: '메뉴명'
        },
        width: 150,
        visible: true
      },
      {
        name: 'aclc',
        fieldName: 'aclc',
        header: {
          text: '생성'
        },
        width: 20,
        visible: true,
        styles: {
          textAlignment: 'center'
        }
      },
      {
        name: 'aclr',
        fieldName: 'aclr',
        header: {
          text: '조회'
        },
        width: 20,
        visible: true,
        styles: {
          textAlignment: 'center'
        }
      },
      {
        name: 'aclu',
        fieldName: 'aclu',
        header: {
          text: '수정'
        },
        width: 20,
        visible: true,
        styles: {
          textAlignment: 'center'
        }
      },
      {
        name: 'acld',
        fieldName: 'acld',
        header: {
          text: '삭제'
        },
        width: 20,
        visible: true,
        styles: {
          textAlignment: 'center'
        }
      },
      {
        name: 'extacl',
        fieldName: 'extacl',
        header: {
          text: '추가권한'
        },
        width: 50,
        visible: true
      }
    ]
  },
  mounted: function() {
    // 화면 로드시 자동 조회

    Promise.all([getSystems()]).then(responses => {
      // 1. 시스템 리스트
      this.systemList = responses[0]
      this.userGroupGrid.retrieveData.app_id = this.envsSys
      //      console.log('this.systemList :', this.systemList);
    })
  },
  computed: {
    retrieveuserGroupGrid() {
      // 사용자별 권한 그리드 데이터 조회
      return getUserGroups
    },
    retrieveMenuGrid() {
      // 그리드 데이터 조회
      return getUserAuth
    }
  },
  watch: {
    'popup.retrieveData.user_id': function(newValue, oldValue) {
      this.userGroupGrid.retrieveData.user_id = newValue
    }
  },
  methods: {
    search() {
      if (this.$refs.form.validate()) {
        //      this.userGroupGrid.retrieveData.user_id = this.popup.retrieveData.user_id
        this.$refs.userGroupGrid.retrieve()
        this.$refs.menusGrid.retrieve()
      }
    },
    insertRow() {
      this.$refs.menusGrid.addRow()
    },
    addRow() {
      this.$refs.menusGrid.addRow()
    },
    // getUserGroups() {
    //   this.$refs.userGroupGrid.retrieve()
    // },

    // 팝업 닫기
    closeUserListPopup(result) {
      if (result.ok) {
        if (result.id === 'userListPopup') {
          this.$refs.memberSearchComp.addSelectedUser()
        } else {
          // this.$refs.deptSearchComp.addSelectedItem()
        }
      }
      this.flags[result.id] = false
    },
    // '프로그램 목록 팝업으로 추가' 버튼 클릭시 실행(팝업 열기)
    openUserListPopup() {
      // 팝업을 연다
      if (this.radio1 === 'A') {
        this.flags.userListPopup = true
      } else {
        this.flags.deptListPopup = true
        this.flags.userListPopup = false
      }
    },
    getSelectedDept(deptinfo) {
      this.popup.retrieveData.user_id = deptinfo.asgn_cd
      this.userGroupGrid.retrieveData.user_id = deptinfo.asgn_cd
      this.userGroupGrid.retrieveData.user_nm = deptinfo.asgn_shrt_nm

      this.flags.deptListPopup = false
    },
    // 팝업 '선택된 프로그램 추가' 버튼 클릭시 실행
    getSelectedUser(checkRowData) {
      this.popup.retrieveData.user_id = checkRowData.user_id
      this.userGroupGrid.retrieveData.user_id = checkRowData.user_id
      this.userGroupGrid.retrieveData.user_nm = checkRowData.user_nm
      // 팝업을 닫는다.
      this.flags.userListPopup = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
  }
</style>
<style lang="scss">
.user_id-tf {
  .v-input__append-outer {
    margin: 0px 0px 0px 4px !important;
  }
}
</style>
